var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquadsSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7.75,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.65,
    cy: 9.55,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.35,
    cy: 9.55,
    r: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 18.55C8.25 16.25 9.95 14.7 12 14.7C14.05 14.7 15.75 16.25 15.75 18.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95 18.55C3.95 16.85 5.3 15.65 7.05 15.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.05 18.55C20.05 16.85 18.7 15.65 16.95 15.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.35V2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65 4.15L9.2 3.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.35 4.15L14.8 3.45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquadsSidebar);
export default __webpack_public_path__ + "static/media/squadsSidebar.5d2aa5f66239bdf84755c4b9c118c6c3.svg";
export { ForwardRef as ReactComponent };